import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["message", "commentList"]

    onPostSuccess(event) {
        let [data, status, xhr] = event.detail;
        this.commentListTarget.innerHTML += xhr.response;
        this.messageTarget.value = "";
    }

}
